<template>
  <div>
    <div class="add-role-heading flex items-center justify-between pt-10">
      <h3>User Roles</h3>
      <vs-button
        @click="openAddEditRolePopup()"
        class="sm:w-auto sm:order-normal order-3 sm:mt-0 mt-4 add-line-button flex items-center justify-center mt-5"
        color="#00ccfe"
        type="filled"
        ><feather-icon icon="PlusIcon" svgClasses="h-6 w-6" />&nbsp; ADD NEW
        ROLE
      </vs-button>
    </div>

    <div>
      <ag-grid-vue
        ref="agGridTable"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="getRoleList"
        rowSelection="multiple"
        rowMultiSelectWithClick="false"
        suppressRowClickSelection="true"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>
      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>

    <vs-popup
      class="holamundo add-new-user-role"
      title="Lorem ipsum dolor sit amet"
      :active.sync="IsAddEditPopupOpened"
      @close="IsAddEditPopupOpened = true"
    >
      <div class="user-popup">
        <vs-button
          @click="IsAddEditPopupOpened = false"
          radius
          color="#000"
          type="flat"
          icon-pack="feather"
          icon="icon-x"
          class="close"
        ></vs-button>
        <div class="add-role-heading flex items-center justify-center">
          <h3 v-if="roleName && roleId">Edit User Roles</h3>
          <h3 v-else>Add New User Roles</h3>
        </div>
        <div class="user-roles-add-form">
          <!-- <div class="mt-1 access-type">
            <p>Access Type <span class="rqrd">*</span></p>
            <div class="mt-3">
              <ul class="centerx flex justify-start items-start">
                <li>
                  <vs-radio
                    v-model="roleAccessType"
                    color="#00ccfe"
                    vs-value="Employee"
                    class="mr-5"
                    >Employee</vs-radio
                  >
                </li>
                <li>
                  <vs-radio
                    v-model="roleAccessType"
                    color="#00ccfe"
                    vs-value="Management"
                    class="mr-5"
                    >Management</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div> -->

          <label>Name <span class="rqrd">*</span></label>
          <input
            type="text"
            name="roleName"
            value=""
            placeholder="Enter Role Name"
            v-model="roleName"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('roleName')"
            >The Role Name field is required</span
          >

          <div>
            <label>Select Color Code</label>
            <div class="color-choose">
              <div class="flex justify-start items-center">
                <feather-icon icon="Edit2Icon" svgClasses="h-4 w-4" />
                <p>{{ roleColorCode }}</p>
              </div>
              <input
                type="color"
                name="colorCode"
                value=""
                placeholder="Add Color Code"
                v-model="roleColorCode"
              />
            </div>
          </div>

          <label>Add Icon</label>
          <div class="upload-role-image">
            <div class="role-image-sec">
              <div class="Location-image-area">
                <feather-icon
                  v-show="!roleImgUrl"
                  icon="ImageIcon"
                  svgClasses="h-12 w-12"
                  @click="openFileUpload"
                />
                <img v-show="roleImgUrl" :src="roleImgUrl" class="" />
              </div>
            </div>
            <div class="image-desc">
              <h4>Upload to add<br />role image</h4>
              <p>
                Image should be 1:1 ratio in JPG, PNG<br />Max file size 2MB
              </p>
              <div class="choosefile-button">
                <input
                  id="uploadLocImg"
                  type="file"
                  class="hidden"
                  ref="update_location_input"
                  @change="update_avatar($event, '200x200')"
                  accept="image/*"
                />
                <p @click="openFileUpload">Choose File</p>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-center align-center mt-8 pb-4">
          <vs-button
            @click="resetRoles()"
            color="#d1d3d7"
            type="border"
            class="cancel-line-button mr-2"
            >CANCEL</vs-button
          >
          <vs-button
            :disabled="!validateForm"
            @click="before_save(false)"
            color="#00ccfe"
            type="filled"
            class="add-line-button"
            >Save</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <vs-popup
      class="holamundo registrationType-popup"
      title="Crop Image"
      :active.sync="popupCropper"
      v-if="cropImageUrl"
      style="z-index: 53001"
    >
      <h5>
        Aspect Ratio for this image is {{ displayImageRatio }}. To crop this
        image, simply drag and click Upload
      </h5>
      <photowall-resize-component
        :key="resetCropper"
        v-bind:aspectValue="imageRatio"
        :sourceImage="cropImageUrl"
        @croppedImagePath="croppedImagePath"
      />
    </vs-popup>
  </div>
</template>


<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
//store
import moduleCheckinRoleManagement from "@/store/checkin-role-management/moduleCheckinRoleManagementActions.js";
import CellRendererRoleActions from "./cell-renderer/CellRendererRoleActions.vue";
import CellRendererRoleStatus from "./cell-renderer/CellRendererRoleStatus.vue";

import { bus } from "../../main";
import PhotowallResizeComponent from "../photowall/PhotowallResizeComponent.vue";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
// Store Module

export default {
  components: {
    AgGridVue,
    CellRendererRoleActions,
    PhotowallResizeComponent,
    CellRendererRoleStatus,
  },

  data() {
    return {
      resetCropper: 0,
      cropImageUrl: null,
      popupCropper: false,
      displayImageRatio: "1:1",
      imageRatio: 1 / 1,
      // imgSrc: this.data.ImageUrl == "" ||
      //   this.data.ImageUrl == undefined
      //     ? ""
      //     : this.data.ImageUrl,
      roleId: "",
      roleName: "",
      roleColorCode: "",
      roleAccessType: "Employee",
      roleImgUrl: "",
      roleImgUrlFile: {},
      IsAddEditPopupOpened: false,
      gridApi: null,
      roleLocationData: {},
      roleData: [],
      gridOptions: {},
      columnDefs: [
        {
          headerName: "Name",
          field: "Name",
          width: 300,
          filter: true,
          unSortIcon: true,
        },
        {
          headerName: "Color Code",
          field: "Color",
          filter: true,
          unSortIcon: true,
          width: 350,
        },
        // {
        //   headerName: "Access Type",
        //   field: "AccessType",
        //   filter: true,
        //   unSortIcon: true,
        //   width: 250,
        // },
        // {
        //   headerName: "Status",
        //   field: "IsPublished",
        //   filter: true,
        //   width: 150,
        //   cellRendererFramework: "CellRendererRoleStatus",
        //   cellRendererParams: (params) => {
        //     console.log("params===", params.data);
        //     return {
        //       data: params.data,
        //     };
        //   },
        // },
        {
          headerName: "Actions",
          filter: false,
          sortable: false,
          width: 150,
          cellRendererFramework: "CellRendererRoleActions",
          cellRendererParams: (params) => {
            return {
              data: params.data,
            };
          },
          pinned: "right",
        },
      ],
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
    };
  },
  watch: {},
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
    getRoleList() {
      return this.roleData;
    },
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {
    changeRoleStatus(data) {
      // data.IsPublished = false;
      this.$vs.loading();

      this.$store
        .dispatch("checkinRoleManagement/updateRole", {
          id: data.RoleId,
          data: data,
        })
        .then((res) => {
          this.$vs.loading.close();
          if (res.status == 200) {
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Role",
              text: "Role updated successfully.",
            });
            this.fetchRoles();
            this.$emit("saveRoleSuccess");
            this.IsAddEditPopupOpened = false;
            // this.$emit("saveLocationSuccess", 1);
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              title: "success",
              text: "Role not updated successfully.",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            title: "Role",
            text: "Something went wrong!",
          });
        });
    },
    croppedImagePath(blob) {
      console.log("blob====", blob);
      this.roleImgUrl = blob;
      this.popupCropper = false;
    },
    update_avatar(input, fileWH) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }

        this.roleImgUrlFile = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.resetCropper += 1;
          this.cropImageUrl = null;
          this.cropImageUrl = e.target.result;
          this.popupCropper = true;
          //this.imgSrc = e.target.result;
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    openFileUpload() {
      $("#uploadLocImg").click();
    },
    resetRoles() {
      this.roleName = "";
      this.roleColorCode = "";
      this.roleImgUrl = "";
      this.roleId = "";
      this.roleAccessType = "Employee";
      this.IsAddEditPopupOpened = false;
    },
    before_save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.createUserRoles();
        }
      });
    },
    createUserRoles() {
      if (!this.validateForm) return;
      this.$vs.loading();
      var data_local = {};
      console.log("role===", this.roleImgUrlFile.name);
      debugger;

      if (this.roleId) {
        if (this.roleImgUrlFile && this.roleImgUrlFile.name) {
          data_local = {
            Name: this.roleName,
            Color: this.roleColorCode,
            ImageUrl: this.roleImgUrl,
            AccessType: this.roleAccessType,
            File: this.roleImgUrlFile,
          };
        } else {
          data_local = {
            Name: this.roleName,
            Color: this.roleColorCode,
            ImageUrl: this.roleImgUrl,
            AccessType: this.roleAccessType,
          };
        }
      } else {
        if (this.roleImgUrlFile && this.roleImgUrlFile.name) {
          data_local = {
            Name: this.roleName,
            Color: this.roleColorCode,
            ImageUrl: this.roleImgUrl,
            AccessType: this.roleAccessType,
            File: this.roleImgUrlFile,
            IsPublished: true,
          };
        } else {
          data_local = {
            Name: this.roleName,
            Color: this.roleColorCode,
            ImageUrl: this.roleImgUrl,
            AccessType: this.roleAccessType,
            IsPublished: true,
          };
        }
      }

      if (this.roleId) {
        this.$store
          .dispatch("checkinRoleManagement/updateRole", {
            id: this.roleId,
            data: data_local,
          })
          .then((res) => {
            this.$vs.loading.close();
            if (res.status == 200) {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Role",
                text: "Role updated successfully.",
              });
              this.fetchRoles();
              this.$emit("saveRoleSuccess");
              this.IsAddEditPopupOpened = false;
            } else {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                title: "success",
                text: "Role not updated successfully.",
              });
              this.IsAddEditPopupOpened = false;
            }
          })
          .catch((err) => {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              title: "Role",
              text: "Something went wrong!",
            });
            this.IsAddEditPopupOpened = false;
          });
      } else {
        console.log("2");
        this.$store
          .dispatch("checkinRoleManagement/addRole", {
            data: data_local,
          })
          .then((res) => {
            this.$vs.loading.close();
            if (res.status == 200) {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Role",
                text: "Role created successfully.",
              });
              this.fetchRoles();
              this.$emit("saveRoleSuccess");
              this.IsAddEditPopupOpened = false;
            } else if (res.status == 500) {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                title: "Role",
                text: res.message,
              });
              this.IsAddEditPopupOpened = false;
            } else {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Role",
                text: res.message,
              });
              this.IsAddEditPopupOpened = false;
            }
          })
          .catch((err) => {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              title: "Role",
              text: "Something went wrong!",
            });
            this.IsAddEditPopupOpened = false;
          });
      }
    },
    fetchRoles() {
      var self = this;
      this.$vs.loading();
      this.$store
        .dispatch("checkinRoleManagement/fetchGeoCheckinRoles")
        .then((res) => {
          console.log("res===111==", res);
          if ((res.status = 200)) {
            //this.roleData = res.data[0];
            self.roleData = [];

            if (res.data && res.data.length > 0) {
              res.data[0].map(function (item) {
                if (item.IsPublished) {
                  console.log("item==", item.Name);

                  self.roleData.push(item);
                }
              });
            }

            if (self.roleData && self.roleData.length > 0) {
              this.roleData.sort((a, b) => {
                console.log("a====", a.CreatedDate["_seconds"]);

                const aDate = new Date(a.CreatedDate["_seconds"] * 1000);
                const bDate = new Date(b.CreatedDate["_seconds"] * 1000);
                return bDate.getTime() - aDate.getTime();
              });
            }
          }
          this.pageLoaded = true;
          this.$vs.loading.close();
        });
    },
    openAddEditRolePopup() {
      this.roleName = "";
      this.roleColorCode = "";
      this.roleImgUrl = "";
      this.roleAccessType = "Employee";
      this.IsAddEditPopupOpened = true;
    },
  },
  mounted() {
    this.gridOptions.api.showLoadingOverlay();
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  destroyed() {
    bus.$off("editRole");
    bus.$off("changeRoleStatus");
  },
  created() {
    if (!moduleCheckinRoleManagement.isRegistered) {
      this.$store.registerModule(
        "checkinRoleManagement",
        moduleCheckinRoleManagement
      );
      moduleCheckinRoleManagement.isRegistered = true;
    }
    this.fetchRoles();
    bus.$on("editRole", async (role) => {
      this.roleName = role.Name;
      this.roleColorCode = role.Color;
      this.roleImgUrl = role.ImageUrl;
      this.roleId = role.RoleId;
      this.roleAccessType = role.AccessType ? role.AccessType : "Employee";

      this.IsAddEditPopupOpened = true;
    });

    bus.$on("changeRoleStatus", async (role) => {
      this.changeRoleStatus(role);
    });
  },
};
</script>